import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class NotificationTaskAssignedMeta extends BaseEntityModel {
  parentId?: string;
  userId?: number;

  constructor(model: Partial<NotificationTaskAssignedMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.userId = model.userId;
  }
}
